/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { ajax } from '@src/common/ajax';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import {} from '@src/common/util/getResultStatus';

import {
  LaCachedEdges,
  LaEdgeApiItem,
  LaEdgesRequest,
  LaEdgesResponse,
  LaFetchEdgesResponse,
  LaFilterPanelState,
} from '../types';
import { laFilterPanelToHash } from '../mothership/laFilterPanelToHash';
import { getDefaultLaEdgesResponse } from './getDefaultGraphData';
import { MAX_EDGES_FOR_EXPORT, MAX_EDGES_FOR_GRAPH } from './edgeLimits';
import { getResultStatusForEdges } from './getResultStatusForEdges';

const cache: Record<string, LaCachedEdges> = {};

export async function laFetchEdges(
  fpState: LaFilterPanelState,
  limit: number
): Promise<LaFetchEdgesResponse> {
  const cacheKey = laFilterPanelToHash(fpState, limit);

  if (!cache[cacheKey]) {
    cache[cacheKey] = fetchEdges(fpState, limit);
  }

  const cachedResult = await cache[cacheKey];

  if (cachedResult.edges.length === 0) {
    delete cache[cacheKey];
  }

  return cachedResult;
}

async function fetchEdges(
  fpState: LaFilterPanelState,
  limit: number
): Promise<LaFetchEdgesResponse> {
  const edgesRequest: LaEdgesRequest = {
    idType: fpState.idType,
    idValue: fpState.value.trim(),
    nodeTypes: fpState.nodesValue,
    depth: fpState.hop.trim().toLowerCase(),
    maxConnectionsPerIp: fpState.maxIpConnections
      ? +fpState.maxIpConnections
      : null,
    limit,
  };

  const { success, payload } = await ajax<LaEdgesResponse>(
    getDefaultLaEdgesResponse(),
    ApiUrl.laEdges,
    {
      method: 'post',
      body: JSON.stringify(edgesRequest),
    }
  );

  const sourceNodeId = getSourceNodeId(
    payload.content,
    edgesRequest.idValue,
    edgesRequest.idType
  );
  const edgedApiItems = payload.content.filter(beValid);

  const resultStatus = getResultStatusForEdges(
    success,
    payload.total,
    sourceNodeId,
    MAX_EDGES_FOR_GRAPH,
    MAX_EDGES_FOR_EXPORT
  );

  const resp: LaFetchEdgesResponse = {
    resultStatus,
    sourceNodeId,
    edges: edgedApiItems,
  };

  return resp;
}

function beValid(edge: LaEdgeApiItem) {
  return !!edge.id && !!edge.sourceNodeId && edge.targetNodeId;
}

function getSourceNodeId(
  edges: LaEdgeApiItem[],
  idValue: string,
  idType: string
) {
  const sourceNode = edges.find(
    (e) => e.sourceNodeType === idType && e.sourceNodeValue === idValue
  );

  return sourceNode ? sourceNode.sourceNodeId : '';
}
